module.exports = __webpack_public_path__ + "img/year@2x.2cb2b0e9.png";